export default __webpack_public_path__ + "static/media/dashboard.ca51e339.png";